import axios from '../config/axiosConfig';
import ApiKey from './constant/ApiKey';
import { ADMIN_URL, NOTIFICATION_URL } from './constant/BaseApiUrl';

export default class AdminSetupService {
  getEmailConfig() {
    return axios.get(`${NOTIFICATION_URL}email`);
  }
  updateEmailConfig(payload) {
    return axios.post(`${NOTIFICATION_URL}email`, payload);
  }

  getExpiredConfig() {
    return axios.get(`${ADMIN_URL}${ApiKey.EMAIL_CONFIG}`);
  }

  getConfigOption() {
    return axios.get(`${ADMIN_URL}${ApiKey.OPTION_CONFIG}`);
  }

  updateConfigOption(payload: any) {
    return axios.post(`${ADMIN_URL}${ApiKey.OPTION_CONFIG}`, payload);
  }

  updateExpiredConfig(payload: any) {
    return axios.put(`${ADMIN_URL}${ApiKey.EMAIL_CONFIG}`, payload);
  }

  getOneWayOpenJawConfig(jawType: string) {
    return axios.get(`${ADMIN_URL}${ApiKey.FLIGHT_ROUTE_EXCLUSION}/${jawType}`);
  }

  updateOneWayOpenJawConfig(payload: any) {
    return axios.put(`${ADMIN_URL}${ApiKey.FLIGHT_ROUTE_EXCLUSION}`, payload);
  }

  getSpecialPromotionConfiguration() {
    return axios.get(`${ADMIN_URL}${ApiKey.SPECIAL_CONFIGURATION}`);
  }

  updateSpecialPromotionConfiguration(payload: any) {
    return axios.put(`${ADMIN_URL}${ApiKey.SPECIAL_CONFIGURATION}`, payload);
  }

  getNetMarginConfig() {
    return axios.get(`${ADMIN_URL}${ApiKey.NET_MARGIN}`);
  }

  updateNetMarginConfig(payload: any) {
    return axios.put(`${ADMIN_URL}${ApiKey.NET_MARGIN}`, payload);
  }

  getDepartureConfig() {
    return axios.get(`${ADMIN_URL}${ApiKey.DEPARTURE_CONFIG}`);
  }

  updateDepartureConfig(payload: any) {
    return axios.put(`${ADMIN_URL}${ApiKey.DEPARTURE_CONFIG}`, payload);
  }

  getMaxRoomConfig() {
    return axios.get(`${ADMIN_URL}${ApiKey.MAX_ROOMS_CONFIG}`);
  }

  updateMaxRoomConfig(payload: any) {
    return axios.post(`${ADMIN_URL}${ApiKey.MAX_ROOMS_CONFIG}`, payload);
  }

  checkMaxRooms(payload: any) {
    return axios.post(`${ADMIN_URL}${ApiKey.CHECK_MAX_ROOMS}`, payload);
  }

  getMinimumConfig() {
    return axios.get(`${ADMIN_URL}${ApiKey.MIN_GROUP_SIZE}`);
  }

  updateMinimumConfig(payload: any) {
    return axios.post(`${ADMIN_URL}${ApiKey.MIN_GROUP_SIZE}`, payload);
  }
}
